module.exports = __webpack_public_path__ + "img/yixiaoxingtoubu.b180f766.png";